import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { ButtonGroup, FormGroup, IconButton, Stack, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import YouTube, { YouTubeProps } from 'react-youtube';
import GaleriaComp from './GaleriaComp';
import Service from '../../util/Service';

export default function ImgCompDialog(pros) {
  const { open, setOpen, action } = pros
  const [tipo, setTipo] = React.useState('url');
  const [url, setUrl] = React.useState();
  const [anexo, setAnexo] = React.useState();
  const [wait, setWait] = React.useState(false);
  const [nome, setNome] = React.useState('');
  const [tipoAnexo, setTipoAnexo] = React.useState('');
  const [descricao, setDescricao] = React.useState('');

  const [erroTipo, setErroTipo] = React.useState();

  const handleClose = (r) => {
    if (tipo === 'url') {
      if (action) action(url);
      setOpen(false);
    } else if (tipo === 'upload') {
      if (!nome) {
        alert('Indique o nome para identificação do upload')
        return;
      }
      if (!tipoAnexo || tipoAnexo.length < 2) {
        setErroTipo('Indique o tipo para filtrar do upload');
        return;
      }

      const dado = {
        nome: nome,
        tipo: tipoAnexo,
        desc: descricao
      }
      console.log(dado);
      Service.POST("/api/security/salvaAnexo", dado).then(r => {
        console.log(r);
        uploadArquivo(r)
      }).catch(e => {
        console.log("erro--->", e)
        alert(e);
      })
    } else if (tipo === 'galeria') {

      console.log(r);

      // return;
      if (action) action(r);

      setOpen(false);
    }
  };
  function uploadArquivo(ret) {
    let input = document.getElementById("file");
    const file = input.files;

    let dados = new FormData();
    dados.append('file', file[0]);

    Service.UPLOAD("/api/security/anexar/" + ret.id, dados).then(r => {
      console.log(r);
      setOpen(false);
      if (action) action(r);

    }).catch(e => {
      console.log("erro--->", e)
      alert(e);
    })
  }

  const opts = {
    height: '390',
    width: '640',
    // playerVars: {
    //   // https://developers.google.com/youtube/player_parameters
    //   autoplay: 1,
    // },
  };
  const _onReady = (event) => {
    // access to player in all event handlers via event.target
    event.target.pauseVideo();
  }

  const handleTipoAnexo = (tp) => {
    setTipo(tp);
    if (tp === 'upload') addAnexo();
  }

  const montaComponenteTipo = () => {
    if (tipo === 'url') {
      return (
        <TextField id="id-url" label="Url" variant="outlined"
          fullWidth value={url ? url : ''} onChange={(e) => setUrl(e.target.value)} />
      )
    } else if (tipo === 'upload') {
      return (
        <center>
          <Stack direction="row" spacing={2}>
            <Stack spacing={2} sx={{ m: 1 }}>
              <TextField label="Nome" variant="outlined" value={nome} onChange={(e) => setNome(e.target.value)} />
              <TextField
                label="Tipo" variant="outlined" value={tipoAnexo} onChange={(e) => { setTipoAnexo(e.target.value); setErroTipo(); }}
                error={erroTipo && erroTipo.length > 1}
                helperText={erroTipo}
              />
              <TextField label="Descrição" variant="outlined" multiline rows={4} value={descricao} onChange={(e) => setDescricao(e.target.value)} />
            </Stack>
            <img src="#" alt="Preview Uploaded Image" id="file-preview" width="250" height="300" />
          </Stack>
        </center>
      )
    } else if (tipo === 'galeria') {
      return (
        <GaleriaComp onAction={handleClose} />
      )
    }
  }
  const addAnexo = () => {
    let file = document.getElementById("file");
    file.click();
  }
  const upload = () => {
    let input = document.getElementById("file");
    // let dados = new FormData();
    // setWait(true);
    // dados.append('file', file.files[0]);
    const file = input.files;

    if (file) {
      const fileReader = new FileReader();
      const preview = document.getElementById('file-preview');
      fileReader.onload = event => {
        preview.setAttribute('src', event.target.result);
      }
      console.log(file[0]);
      setNome(file[0].name);

      fileReader.readAsDataURL(file[0]);
    }
    // Service.upload(dados).then((result) => {
    //     setWait(false);
    //     var nm = file.value.split(/(\\|\/)/g).pop();

    //     let anexo = {
    //         nome: nm,
    //         uuid: result.uuid
    //     };
    //     setAnexo(anexo);
    //     file.value = null;
    // }).catch((e) => {
    //     setWait(false);
    //     setMensagem({ tipo: 'error', mensagem: e.message });
    // });
  }
  const montaUrl = () => {
    if (url) {
      console.log(url);
      if (url.includes('youtube')) {
        let ext = url.split("/");
        let tp = null;
        if (ext.length > 1) {
          tp = ext[ext.length - 1]
        }
        console.log(tp)
        if (tp === null) return (
          <p>Não foi possivel inferir o tipo de anexo</p>
        )
        return (
          <YouTube videoId={tp} opts={opts} />
        )
      }

      let ext = url.split("\.");
      console.log(ext)
      let tp = null;
      if (ext.length > 1) {
        tp = ext[ext.length - 1]
      }
      console.log(tp)
      if (tp === null) return (
        <p>Não foi possivel inferir o tipo de anexo</p>
      )
      return (
        <img src={url} />
      )
    }
  }

  return (
    <Dialog
      fullWidth
      maxWidth="lg"
      open={open}
      onClose={handleClose}
    >
      <DialogTitle>Adicionar Anexo</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => setOpen(false)}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ minHeight: '300px' }}>
        <center>
          <ButtonGroup variant="outlined" aria-label="Basic button group">
            <Button onClick={() => handleTipoAnexo('url')}>URL</Button>
            <Button onClick={() => handleTipoAnexo('upload')}>Upload</Button>
            <Button onClick={() => handleTipoAnexo('galeria')}>Galeria</Button>
          </ButtonGroup>
        </center>
        <Box
          noValidate
          component="form"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            m: 'auto',
            marginTop: 2
          }}
        >
          <Stack spacing={2}>
            {montaComponenteTipo()}
            {montaUrl()}
          </Stack>
        </Box>
      </DialogContent>
      {(tipo === 'url' || tipo === 'upload') &&
        <DialogActions>
          <Button onClick={handleClose}>Ok</Button>
        </DialogActions>}
      <input type="file" id="file" style={{ display: 'none' }} onChange={upload} />
    </Dialog>
  );
}